module.exports = __webpack_public_path__ + "static/media/calendar.5f748003.svg";